import axios from "axios";
import { createContext } from "react";

const SysadminAgentTemplateContext = createContext();

/**
 * Sysadmin-only template management (api/sysadmin/agent/*). Regular users never manage
 * templates — they only instantiate published ones (see AgentContext.getInstallableTemplates).
 */
export const SysadminAgentTemplateContextProvider = ({ children }) => {
  const getAgentDefinitions = (applicationId) =>
    axios.get("/api/sysadmin/agent/definitions" + (applicationId ? `?applicationId=${applicationId}` : ""));
  const getAgentDefinition = (id) => axios.get("/api/sysadmin/agent/definitions/" + id);
  const createAgentDefinition = (data) => axios.post("/api/sysadmin/agent/definitions", data);
  const updateAgentDefinition = (data) => axios.put("/api/sysadmin/agent/definitions/" + data.id, data);
  const deleteAgentDefinition = (id) => axios.delete("/api/sysadmin/agent/definitions/" + id);
  const submitAgentDefinition = (id) => axios.post(`/api/sysadmin/agent/definitions/${id}/submit`);
  const withdrawAgentDefinition = (id) => axios.post(`/api/sysadmin/agent/definitions/${id}/withdraw`);
  const getAgentDefinitionVersions = (id) => axios.get(`/api/sysadmin/agent/definitions/${id}/versions`);
  const rollbackAgentDefinition = (id, version) =>
    axios.post(`/api/sysadmin/agent/definitions/${id}/rollback`, { version });
  const getAgentModels = () => axios.get("/api/sysadmin/agent/models");
  // Resolve (or create) a template-ref test agent in the sysadmin's own account.
  const createTestAgent = (id) => axios.post(`/api/sysadmin/agent/definitions/${id}/test-agent`);

  return (
    <SysadminAgentTemplateContext.Provider
      value={{
        getAgentDefinitions,
        getAgentDefinition,
        createAgentDefinition,
        updateAgentDefinition,
        deleteAgentDefinition,
        submitAgentDefinition,
        withdrawAgentDefinition,
        getAgentDefinitionVersions,
        rollbackAgentDefinition,
        getAgentModels,
        createTestAgent,
      }}
    >
      {children}
    </SysadminAgentTemplateContext.Provider>
  );
};

export default SysadminAgentTemplateContext;
